import styled from '@emotion/styled';
import { Paper, Box, Typography, Avatar } from '@mui/material';

export const ChatArea = styled(Paper)(() => ({
    flexGrow: 1, // Takes available space above input
    overflowY: 'auto',
    padding: '20px',
    backgroundColor: 'var(--grey-50)', 
    marginBottom: '15px', // Space before the input area
    border: `1px solid var(--grey-200)`,
    boxShadow: 'none',
    display: 'flex',
    flexDirection: 'column',
}));

export const PlaceholderBox = styled(Box)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    textAlign: 'center',
    color: 'var(--grey-500)',
});

export const PlaceholderText = styled(Typography)({
    marginTop: '15px',
    fontSize: '1rem',
});

export const MessageRow = styled(Box)(({ messagerole }) => ({ 
    display: 'flex',
    marginBottom: '15px',
    justifyContent: messagerole === 'user' ? 'flex-end' : 'flex-start',
}));

export const MessageBubble = styled(Paper)(({ messagerole }) => ({ 
    padding: '10px 15px',
    borderRadius: '15px',
    maxWidth: '100%',
    backgroundColor: messagerole === 'user' ? 'var(--secondary-main)' : 'var(--background-paper)',
    color: messagerole === 'user' ? 'white' : 'var(--grey-900)',
    boxShadow: '0 1px 2px rgba(0, 0, 0, 0.1)',
    wordWrap: 'break-word', 
    whiteSpace: 'pre-wrap', 
}));

export const Timestamp = styled(Typography)(({ messagetype }) => ({
    fontSize: '0.7rem',
    color: messagetype === 'user' ? 'rgba(255, 255, 255, 0.7)' : 'var(--grey-500)',
    marginTop: '5px',
    textAlign: 'right',
}));

export const BotAvatar = styled(Avatar)(() => ({
    width: 32,
    height: 32,
    marginRight: '10px',
    backgroundColor: 'var(--secondary-main)',
}));

export const ErrorMessage = styled(Box)(() => ({
    padding: '10px 15px',
    borderRadius: '8px',
    backgroundColor: 'var(--error-light)',
    color: 'var(--error-dark)',
    border: `1px solid var(--error-main)`,
    margin: '10px 0',
    fontSize: '0.9rem',
}));

export const LoadingIndicator = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '10px',
}); 